import { TextField } from "@mui/material";
import { GameCssStyles } from "../../GameManagement/GameCssStyles";

const MetadataEditableField = ({ isFullWidth, label, value, onChange }) => {
    return (
        <TextField
            fullWidth={isFullWidth}
            label={label}
            multiline={false}
            rows={1}
            value={value || ''}
            onChange={(e) => {
                onChange(e.target.value)
            }}
            sx={GameCssStyles.formSingleLineTextField_sx}
        />
    );
}

export default MetadataEditableField;